import { ArrowDownRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const process = [
  "Research the problem",
  "Design the system",
  "Build the prototype",
  "Test in realistic conditions",
  "Measure performance",
  "Improve iteratively",
];

export function AboutSection() {
  return (
    <section id="about" className="section shell">
      <SectionHeading
        number="01"
        eyebrow="About / operating range"
        title="Between software and the physical world."
        description="I like work that crosses boundaries: models that become product features, sensors that become decisions, and research questions that become testable systems."
      />
      <div className="about-grid">
        <div className="about-copy panel">
          <span className="comic-caption">Builder’s note</span>
          <p className="about-lead">
            I work across AI research, software engineering, web development, data systems, robotics and embedded hardware, choosing the tools the problem actually needs.
          </p>
          <div className="about-columns">
            <p>
              My projects range from web applications and structured data workflows to autonomous robots using LiDAR, cameras and embedded controllers. I am especially interested in computer vision, practical machine learning and intelligent robotics.
            </p>
            <p>
              I am also exploring NLP, retrieval-augmented systems, intelligent automation and AI-enhanced web experiences, always with an eye on clarity, evaluation and useful implementation.
            </p>
          </div>
        </div>
        <aside className="process-panel panel" aria-labelledby="process-title">
          <div className="process-heading">
            <p className="eyebrow">How I work</p>
            <h3 id="process-title">From question to evidence.</h3>
          </div>
          <ol>
            {process.map((step, index) => (
              <li key={step}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                {step}
                {index < process.length - 1 && <ArrowDownRight aria-hidden="true" />}
              </li>
            ))}
          </ol>
        </aside>
      </div>
    </section>
  );
}
